module.exports = __webpack_public_path__ + "static/img/img-kang-fachry.2ac602d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-kang-fachry.png
// module id = G7ae
// module chunks = 36